import { useSelector } from 'react-redux'
import { NavbarArgs, WfmConfig } from 'c1-navbar'
import { NavBar } from 'c1-navbar/dist/react'
import Alerts from '../Alerts'
import { UserSettings } from './UserSettings'
import { ContextualHelpLink } from './ContextualHelpLink'
import { RootState } from '../app.reducer'
import { useTranslation } from 'react-i18next'
import { FC } from 'react'
import { FEATURE_FLAGS, useFeatureFlagValue, useIsPathAvailable } from '../../FeatureFlags'
import { getRootRoute } from '../../Permissions/RootRoute'
import { useAuthenticatedUser } from '../../Permissions'
import { useAppSelector } from '../../root.reducer'

export const C1Navbar: FC<{c1user: $TSFIXME, hideNav: boolean}> = ({ c1user, hideNav = false }) => {
  const idToken = useSelector((state: RootState) => state.app.forgerockIdToken)
  const { t } = useTranslation()
  const isPathAvailable = useIsPathAvailable()
  const authenticatedUser = useAuthenticatedUser()
  const wasAuthFR = useAppSelector(state => state.app.wasAuthFR)
  const landingPage = useAppSelector(state => state.app.landingPage)
  const wfmConfig = useSelector((state: RootState) => state.app.wfmMenuItems ?? undefined)
  const theme = useSelector((state: RootState) => state.app.theme)
  const hasWFM = !!wfmConfig?.wfmBaseUrl
  const errorMessage = wfmConfig?.error ?? ''
  const wfmSuccessConfig: WfmConfig = { wfmBaseUrl: wfmConfig?.wfmBaseUrl, navItems: wfmConfig?.navItems ?? {} }
  const wfmErrorConfig: WfmConfig = { wfmBaseUrl: wfmConfig?.wfmBaseUrl, navItems: { errorItem: { name: t(errorMessage), isPermitted: true, url: 'WFM/#/', external: false } } }
  const c1BaseUrl = location.pathname.replace(/\/$/, '')
  const [route, _] = getRootRoute(c1BaseUrl, wasAuthFR, wfmConfig, authenticatedUser, isPathAvailable, landingPage)

  const navbarConfig: NavbarArgs = {
    c1BaseUrl: location.origin,
    user: c1user,
    enableWfm: hasWFM,
    distributeColumns: true,
    forgerockIdToken: idToken ?? null,
    innovationCenterUrl: useFeatureFlagValue('cher.innovationCenterNavLinkBaseUrl')?.toString(),
    dataLibrary: useFeatureFlagValue(FEATURE_FLAGS.CDM_DATA_LIBRARY) === true,
    enableSmartTags: useFeatureFlagValue(FEATURE_FLAGS.ANALYTICS_ENABLE_SMART_TAG) === true,
    settings: useFeatureFlagValue(FEATURE_FLAGS.CDM_APP_SETTINGS) === true,
    wfmConfig: errorMessage === '' ? wfmSuccessConfig : wfmErrorConfig,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- FeatureFlag value is string or boolean
    insights: [true, 'true'].includes(useFeatureFlagValue(FEATURE_FLAGS.BI_QS_EMBEDDING) as string | boolean),
    showInsightsWithDXPermissions: false,
    transcriptionSearch: useFeatureFlagValue(FEATURE_FLAGS.ANALYTICS_ENABLE_TRANSCRIPTION_SEARCH) === 'true',
    defaultRoute: useFeatureFlagValue(FEATURE_FLAGS.USE_LANDINGPAGE_SERVICE) === true ? route || '/' : null,
  }

  return (
    <NavBar authenticatedUser={{ user: hideNav ? null : c1user }} theme={theme} c1NavbarConfig={navbarConfig}>
      <Alerts />
      <UserSettings forgerockIdToken={idToken}/>
      <ContextualHelpLink user={c1user}/>
    </NavBar>
  )
}
